import { api } from "@/builders/axios";
import { FilterParams } from "@/builders/types/filter-params";
import { id } from "./id";

const get = function (params?: FilterParams) {
  return api
    .get<{
      count: number;
      next: string;
      previous: string;
      results: Array<{
        title: string;
        course_id: number;
        organization_id: number;
      }>;
    }>("/setup/question-banks", { params })
    .then(({ data }) => data);
};

const post = function (data: {
  title: string;
  subject_id: number;
  topic_id: number;
}) {
  return api.post("/setup/question-banks", data);
};

export const question_banks = {
  get,
  post,
  id,
};
